import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExcludedStateCodeModel, UpdateExcludedStateCodeModel } from 'src/app/models/excluded-statecode/excluded-state-code.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ExcludedStatecodeService } from 'src/app/services/excluded-statecode.service';

@Component({
  selector: 'app-excluded-statecode-update',
  templateUrl: './excluded-statecode-update.component.html',
  styleUrls: ['./excluded-statecode-update.component.css']
})
export class ExcludedStatecodeUpdateComponent implements OnInit {
  updateExcludedStateCode: ExcludedStateCodeModel = new ExcludedStateCodeModel();
  updateExcludedStateCodeModel: UpdateExcludedStateCodeModel = new UpdateExcludedStateCodeModel();
  id: number;
  Loader: boolean = false;

  constructor(private alertify: AlertifyService, private router: ActivatedRoute, private route: Router, private excludedStatecodeService: ExcludedStatecodeService) { }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.id = +param.id;
    })
    this.getStateCodeId();
  }

  getStateCodeId() {
    this.Loader = true;
    this.excludedStatecodeService.GetStateCodeById(this.id)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.updateExcludedStateCodeModel = responseBody.responseData;
        this.updateExcludedStateCode.StateCode = this.updateExcludedStateCodeModel.stateCode;
        this.Loader = false;
      });
  }


  onSubmit() {
    if (this.updateExcludedStateCode.StateCode == undefined || this.updateExcludedStateCode.StateCode == null || this.updateExcludedStateCode.StateCode == "") {
      this.alertify.error("State Code is required");
      return;
    }
    this.Loader = true;
    this.updateExcludedStateCode.Id = this.id;
    this.excludedStatecodeService.ExcludedStateCodeUpdate(this.updateExcludedStateCode)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.updateExcludedStateCode = responseBody.responseData;
          this.alertify.success(responseBody.responseMessage);
          this.route.navigate(['excluded-statecode']);
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
        this.Loader = false;

      })

  }
}
